import { Button } from "@digdir/designsystemet-react";
import {
  type ChangeEvent,
  type KeyboardEvent,
  useEffect,
  useId,
  useRef,
} from "react";
import { cn } from "@/utils";

type UploadFileButtonProps = {
  text: string;
  acceptFileType?: string;
  onFileChanged: (e: ChangeEvent<HTMLInputElement>) => Promise<void> | void;
  className?: string;
};

export const UploadFileButton = ({
  text,
  acceptFileType,
  onFileChanged,
  className,
}: UploadFileButtonProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const inputId = useId();

  useEffect(() => {
    inputRef.current = document.getElementById(inputId) as HTMLInputElement;
  });

  return (
    // Style input field as a button
    <Button
      className={cn("relative", className)}
      // When tabbing, the button is focused, so need to trigger input manually
      // Not using "asChild" prop because input is not "tabbable" due to styling
      // Normal clicks however will propagate down to the input field
      onKeyDown={(e: KeyboardEvent<HTMLButtonElement>) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          inputRef.current?.click();
        }
      }}
    >
      <div>
        <span>{text}</span>
        <input
          id={inputId}
          type="file"
          accept={acceptFileType}
          onChange={onFileChanged}
          // Remove default input styling and make it cover the entire button
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer appearance-none bg-transparent border-0 p-0 m-0 outline-none shadow-none"
        />
      </div>
    </Button>
  );
};
